import React, { memo, useMemo } from 'react'

import { arrayOf, bool, func, instanceOf, number, oneOfType, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { buildVariationTree } from './buildVariationTree'
import TreeNode from './Components/TreeNode/TreeNode'

const idType = oneOfType([string, number])

function Tree({
  variations,
  visibleIds = null,
  positionById,
  openedModelId = null,
  isUploadedModelLoaded,
  isActionLoading,
  onSetAsMain,
  onDelete,
}) {
  const t = useTranslation()
  const roots = useMemo(() => buildVariationTree(variations, visibleIds), [variations, visibleIds])
  const actions = useMemo(
    () => ({ isActionLoading, onSetAsMain, onDelete }),
    [isActionLoading, onSetAsMain, onDelete],
  )
  const activeId = isUploadedModelLoaded || openedModelId == null ? null : String(openedModelId)

  return (
    <div className="variations-tree">
      <ul className="variations-tree__list" aria-label={t('viewerSidebar.enhance.variations.views.tree')}>
        {roots.map(node => (
          <TreeNode
            key={node.variation.id}
            node={node}
            positionById={positionById}
            actions={actions}
            activeId={activeId}
          />
        ))}
      </ul>
    </div>
  )
}

Tree.propTypes = {
  variations: arrayOf(shape({ id: idType.isRequired, parentRunId: idType })).isRequired,
  visibleIds: instanceOf(Set),
  positionById: instanceOf(Map).isRequired,
  openedModelId: idType,
  isUploadedModelLoaded: bool.isRequired,
  isActionLoading: bool.isRequired,
  onSetAsMain: func.isRequired,
  onDelete: func.isRequired,
}

export default memo(Tree)
